const premiumContentWrapperStyles = {
  wrapper: {
    position: "relative",
    width: "100%",
  },
  blurContainer: {
    filter: "blur(5px)",
    pointerEvents: "none",
    userSelect: "none",
    overflow: "hidden",
    width: "100%",
    height: "100%",
  },
  overlayContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1,
  },
  contentBox: {
    background: "rgba(0, 0, 0, 0.7)",
    padding: "30px",
    borderRadius: "8px",
    textAlign: "center",
  },
  messageText: {
    color: "white",
    mb: 2,
    textAlign: "center",
  },
  upgradeButton: {
    maxWidth: "fit-content",
  },
} as const;

export default premiumContentWrapperStyles;
